import { Button, Col, Radio, Row, Space, Typography } from "antd";
import { RadioChangeEvent } from "antd/lib";
import { DraftingCompass, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Exam } from "@types";
import { useEditExam } from "@hooks";
import { getKeycloakRealm } from "@/components/helpers";

interface Props {
  exam: Exam;

}

export const ExamPublish = ({exam}: Props) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [checked, setChecked] = useState<string>();
  const editExam = useEditExam();

  const handleChange = ({ target: { value } }: RadioChangeEvent) => {
    setChecked(value);
  };

  useEffect(() => {
    setChecked(exam.state === 1 ? "save-publish" : "sketch")
  }, [exam]);

  return (
    <Row>
      <Col span={24} style={{textAlign: "center"}}>
        <Radio.Group size="large" onChange={handleChange} value={checked}>
          <Radio value={"sketch"} style={{flexDirection: "column-reverse"}} >
            <div className={checked === "sketch" ? "custom-radio-btn-checked" : "custom-radio-btn"}>
              <Typography.Title level={5} style={{margin: 0}}>{t("pages.examsManagment.publishTab.saveDraft")}</Typography.Title>
              <DraftingCompass style={{width: 48, height: 48}}/>
              <Typography.Paragraph>
              {t("pages.examsManagment.publishTab.status")}:
                <Typography.Text strong> {t("pages.examsManagment.publishTab.inactive")}</Typography.Text>
              </Typography.Paragraph>
              <Typography.Text>
              {t("pages.examsManagment.publishTab.draftDesc")}
              </Typography.Text>
            </div>
          </Radio>
          <Radio value={"save-publish"} style={{flexDirection: "column-reverse"}} >
            <div className={checked === "save-publish" ? "custom-radio-btn-checked" : "custom-radio-btn"}>
              <Typography.Title level={5} style={{margin: 0}}>{t("pages.examsManagment.publishTab.publish")}</Typography.Title>
              <Eye style={{width: 48, height: 48}}/>
              <Typography.Paragraph>
              {t("pages.examsManagment.publishTab.status")}:
                <Typography.Text strong type="warning"> {t("pages.examsManagment.publishTab.active")}</Typography.Text>
              </Typography.Paragraph>
              <Typography.Text>
              {t("pages.examsManagment.publishTab.publishDesc")}
              </Typography.Text>
            </div>
          </Radio>
        </Radio.Group>
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          marginBottom: 0,
        }}
      >
        <Space>
          <Button>{t("pages.examsManagment.cancel")}</Button>
          <Button type="primary" htmlType="submit" loading={editExam.isPending} onClick={() => {
            editExam.mutate({
              ...exam,
              state: checked === "save-publish" ? 1 : 2,
            },  {
              onSuccess: () => navigate(`/${getKeycloakRealm}/`),
            });
          }}>
          {t("pages.examsManagment.saveQuit")}
          </Button>
        </Space>
      </Col>
    </Row>
  );
};
